import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {Spinner} from "react-bootstrap";

function BlurLoading({isGlobal}){
    const [viewLoading, setViewLoading] = useState(false);

    const {loading} = useSelector((state) => state.transferResponse);
    useEffect(() => {
        if (loading === "idle" && !isGlobal) {
            setViewLoading(false);
        } else if (loading === "pending" && !isGlobal) {
            setViewLoading(true);
        } else if (loading === "globalPending" && isGlobal) {
            setViewLoading(true);
        }
    }, [loading]);

    return (
        <>
            {viewLoading ? (
                <>
                    {
                        isGlobal ? (
                            <div id="diff-click-cont"></div>
                        )
                        :
                        <div id="blurry-cont">
                            <div className="loading">
                                <Spinner animation="border" role="status"/>
                            </div>
                        </div>
                    }
                </>
            ): (
                <></>
            )}
        </>
    )
}

export default BlurLoading;